/**
 * looks for elements with [data-pdfviewer]
 * [data-pdf-url] the url to the file that will be displayed
 * [data-pdf-input] the id of the file input element that will upload the file
 * Note: The component will look for [data-pdf-url] first. If not present, then it will look for [data-pdf-input].
 * Creates a span element with [data-pdf-numpages] with the number of pages in the pdf as the value of the data-pdf-numpages attribute.
 * Raises a custom event (pdfPreviewLoaded) when the pdf file is loaded and all elements are in place.
**/
export async function bindPdfViewers(content?: Element | Document | null | undefined) {
    if (!content) {
        content = document;
    }
    content.querySelectorAll<HTMLElement>("[data-pdfviewer]").forEach(elem => {
        import(/* webpackChunkName: "pdf-viewer" */ "./pdf-viewer-class").then(({ default: PdfViewer }) => {
            const viewer = new PdfViewer(elem);
            viewer.loadPdf();
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    bindPdfViewers(document);
});

document.addEventListener("loadPdfPreview", (evt: Event) => {
    bindPdfViewers(document.querySelector((evt as CustomEvent).detail.target));
});
